import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  useState(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/category/0?q=${encodeURIComponent(query.trim())}`);
    }
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
      isActive ? 'text-primary-700' : 'text-foreground-700 hover:text-primary-700'
    }`;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur shadow-sm' : 'bg-background-50/80 backdrop-blur'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="text-xl font-bold tracking-tight text-foreground-950">日漫屋</span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          <NavLink to="/" end className={linkClass}>
            首页
          </NavLink>
          <NavLink to="/category/0" className={linkClass}>
            全部漫画
          </NavLink>
          {categories.slice(0, 5).map((c) => (
            <NavLink key={c.id} to={`/category/${c.id}`} className={linkClass}>
              {c.name}
            </NavLink>
          ))}
          <NavLink to="/about" className={linkClass}>
            关于我们
          </NavLink>
        </div>

        <form
          onSubmit={handleSearch}
          className="hidden items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-3 py-1.5 md:flex"
        >
          <i className="ri-search-line text-foreground-500 text-sm"></i>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="搜索漫画"
            className="w-32 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            aria-label="搜索漫画"
          />
        </form>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-lg border border-background-300/70 text-foreground-700 md:hidden"
          aria-label="打开菜单"
        >
          <i className={mobileOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="grid grid-cols-2 gap-1">
            <NavLink to="/" end className={linkClass}>
              首页
            </NavLink>
            <NavLink to="/category/0" className={linkClass}>
              全部漫画
            </NavLink>
            {categories.map((c) => (
              <NavLink key={c.id} to={`/category/${c.id}`} className={linkClass}>
                {c.name}
              </NavLink>
            ))}
            <NavLink to="/about" className={linkClass}>
              关于我们
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
}